import { useQuery } from "@tanstack/react-query";
import { Layout, Spin } from "antd";
import { isAxiosError } from "axios";
import { Outlet } from "react-router-dom";
import { projectQueries } from "@entities/project";
import { EntityBaseAbilityBuilder, useUpdateAbility } from "@shared/lib/casl";
import { useCoordinator } from "@shared/lib/hooks";
import { Navigate, routes } from "@shared/lib/react-router";
import { NotFoundFallback } from "@shared/ui";
import Navigation from "./navigation";
import "./project-wrapper.scss";

const { Content } = Layout;

const ProjectWrapper = () => {
  const { projectId, isLegacyProject } = useCoordinator();

  const {
    data: project = null,
    isLoading,
    isError,
    error,
  } = useQuery(
    projectQueries.getProject({
      projectId,
      idType: isLegacyProject ? "externalId" : "projectId",
    }),
  );

  useUpdateAbility({
    permissions: project?.permissions,
    abilityBuilder: EntityBaseAbilityBuilder("project"),
  });


  if (isLoading)
    return (
      <div className="project-wrapper-loading">
        <Spin size="large" tip="Загрузка проекта">
          <div className="project-wrapper-loading__spin-placeholder" />
        </Spin>
      </div>
    );

  if (isError) {
    return (
      <NotFoundFallback
        status={isAxiosError(error) ? error.response?.status : undefined}
        className="project-wrapper-not-found"
      />
    );
  }

  if (isLegacyProject) {
    return (
      <Navigate
        to={routes.project.root({ projectId: project?.projectId })}
        replace
      />
    );
  }

  return (
    <Layout >
      <Navigation />
      <Content className="project-wrapper-content">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default ProjectWrapper;
